import React, { useEffect, useState } from 'react';
import { AdminSwitchCases } from './types';
import LoginView from 'components/modules/Admin/SigIn';
import { Layout } from 'components/shared/Layout';
import AdminView from 'components/modules/Admin';
import { useAppSelector } from 'redux/store';
import { selectLoginData } from 'redux/admin/selectors';
import { loginResponse } from 'api/adminApi';
import ChangePasswordView from 'components/modules/Admin/ChangePassword';

export const isBrowser = typeof window !== 'undefined';

export function isLoggedIn(loginData: loginResponse | undefined) {
  if (!isBrowser) {
    return false;
  }
  return loginData?.access_token !== undefined;
}

const AdminPage = () => {
  const loginData = useAppSelector(selectLoginData);
  const [route, setRoute] = useState(AdminSwitchCases.login);

  useEffect(() => {
    if (isLoggedIn(loginData)) {
      setRoute(AdminSwitchCases.adminPage);
    } else {
      setRoute(AdminSwitchCases.login);
    }
  }, [loginData]);

  const handleResetPassword = () => {
    setRoute(AdminSwitchCases.resetPassword);
  };

  const switchView = () => {
    switch (route) {
      case AdminSwitchCases.login:
        return <LoginView />;
      case AdminSwitchCases.resetPassword:
        return (
          <ChangePasswordView
            routeTo={() => {
              setRoute(AdminSwitchCases.login);
            }}
          />
        );
      case AdminSwitchCases.adminPage:
        return (
          <AdminView
            routeTo={() => {
              setRoute(AdminSwitchCases.login);
            }}
            onResetPassword={handleResetPassword}
          />
        );
      default:
        return null;
    }
  };
  return <Layout>{switchView()}</Layout>;
};
export default AdminPage;
